import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

/*
  Generated class for the GlobalService provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
  providedIn: "root",
})
export class GlobalService {
  loadingApp = true;
  // apiUrl = 'https://gestao.ipeeasylife.com.br/api';
  // apiUrl = 'http://localhost:8181/api';
  // apiUrl = 'https://phpstack-224727-1988385.cloudwaysapps.com/api';
  // apiUrl = "https://gestao.easy2learn.com.br/api";
  // apiUrl = "http://192.168.15.5:8181/api";
  // apiUrl = 'https://gestao.pazebemcapuchinhos.com.br/api';
  apiUrl = 'https://gestao.vivasananduva.grupoeasylife.com.br/api';
  informacoes: any = {};
  conheca: any = {};

  constructor(public http: HttpClient) {
    this.informacoes = JSON.parse(window.localStorage.getItem("informacoes"));
    this.informacoes = this.informacoes ? this.informacoes : {};
    this.http.get(this.apiUrl + "/informacoes").subscribe((r) => {
      this.informacoes = r;
      window.localStorage.setItem(
        "informacoes",
        JSON.stringify(this.informacoes)
      );
    });

    this.conheca = JSON.parse(window.localStorage.getItem("conheca"));
    this.conheca = this.conheca ? this.conheca : {};
    this.http.get(this.apiUrl + "/conheca").subscribe((r) => {
      this.conheca = r;
      window.localStorage.setItem("conheca", JSON.stringify(this.conheca));
    });
  }
}
